import React from 'react'
import { Box, Typography } from '@mui/material'

import TableActionButtons from '../../../../components/action_button/TableActionButtons'
import { REFUND_APPROVAL_TEXT } from '../../../constants/refundApprovalText'
import { UI_TEXT_COPY_TABLE, UI_TEXT_DOWNLOAD_TABLE } from '../../../../constants/uiText'
import { UI_COLOR_TEXT_SECTION, UI_COLOR_TEXT_SECTION_MUTED } from '../../../../constants/uiColors'
import RefundApprovalProductsTable from './RefundApprovalProductsTable'

const RefundApprovalProductsSection = ({
  showLineActions,
  isFinalized,
  loading,
  lines,
  copyTooltip,
  onCopyTable,
  onDownloadCsv,
  onScan,
  onEditLine,
  onRejectLine
}) => (
  <>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 2,
        flexWrap: 'wrap',
        mb: 1.5
      }}
    >
      <Box>
        <Typography sx={{ fontSize: 15, fontWeight: 800, color: UI_COLOR_TEXT_SECTION }}>
          {REFUND_APPROVAL_TEXT.productsHeading}
        </Typography>
        <Typography sx={{ fontSize: 12, color: UI_COLOR_TEXT_SECTION_MUTED, mt: 0.25 }}>
          {showLineActions ? REFUND_APPROVAL_TEXT.scanHint : REFUND_APPROVAL_TEXT.productsRecord}
        </Typography>
      </Box>

      {(lines.length > 0 || showLineActions) && (
        <TableActionButtons
          utilityActions={[
            {
              label: UI_TEXT_COPY_TABLE,
              tooltip: copyTooltip,
              ariaLabel: REFUND_APPROVAL_TEXT.copyTableAria,
              icon: 'content_copy',
              onClick: onCopyTable,
              disabled: lines.length === 0
            },
            {
              label: UI_TEXT_DOWNLOAD_TABLE,
              visible: !isFinalized,
              ariaLabel: REFUND_APPROVAL_TEXT.downloadTableAria,
              icon: 'download',
              iconSize: 22,
              onClick: onDownloadCsv,
              disabled: lines.length === 0
            }
          ]}
          primaryAction={{
            visible: showLineActions,
            label: REFUND_APPROVAL_TEXT.scan,
            icon: 'barcode_scanner',
            iconSize: 18,
            onClick: () => onScan(),
            disabled: loading
          }}
        />
      )}
    </Box>

    <RefundApprovalProductsTable
      lines={lines}
      showLineActions={showLineActions}
      loading={loading}
      onEditLine={onEditLine}
      onRejectLine={onRejectLine}
    />
  </>
)

export default RefundApprovalProductsSection
